import { render, staticRenderFns } from "./NewChatDialog.vue?vue&type=template&id=18920085&scoped=true"
import script from "./NewChatDialog.vue?vue&type=script&lang=js"
export * from "./NewChatDialog.vue?vue&type=script&lang=js"
import style0 from "./NewChatDialog.vue?vue&type=style&index=0&id=18920085&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18920085",
  null
  
)

export default component.exports